import { useUpdateTypeModelMutation } from "@/hooks";
import { ModelType } from "@/types";
import { TypeModelFields } from "./type-model-fields";

export function FormTypeModelUpdate({ handleClose, typeModel }: { handleClose: () => void; typeModel: ModelType }) {
  const mutation = useUpdateTypeModelMutation();
  return <TypeModelFields typeModel={typeModel} handleClose={handleClose} isLoading={mutation.isLoading} save={values => {
    if (!values.entity_type) return Promise.reject(new Error("Selecione o destinatário."));
    return mutation.mutateAsync({ ...values, entity_type: values.entity_type, id: typeModel.id });
  }} />;
}
